import React, { useEffect, useState } from "react";
import AvgChart from "./AvgChart";
import EircodePriceChart from "./EircodePriceChart";
import EircodeUndervaluedChart from "./EircodeUndervaluedChart";
import { API, fetchJSON, queryForFilters } from "./propertyData";

export default function AnalyticsModal({ filters }) {
  const [state, setState] = useState({ loading: true });
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setState({ loading: true });
    const names = ["avgprices", "avgpricesbyeircode"];
    if (filters.dataOption === "matchedWithPPR")
      names.push("undervalued_by_eircode");
    Promise.all(
      names.map((name) =>
        fetchJSON(
          `${API}/api/chart/${name}?${queryForFilters(filters)}`,
          controller.signal
        )
      )
    )
      .then((data) => {
        if (!data.every(Array.isArray))
          throw new Error("Invalid chart response");
        if (!controller.signal.aborted) setState({ data });
      })
      .catch(() => {
        if (!controller.signal.aborted)
          setState({ error: "We couldn’t load the trends. Please try again." });
      });
    return () => controller.abort();
  }, [filters, retry]);
  return (
    <section className="analytics" aria-label="Property trends">
      <h2>Property trends</h2>
      <p>
        Charts cover all areas matching your applied filters, regardless of the
        map position. Bedroom, agent and property type filters restrict sales to
        records with matching listings.
      </p>
      <p className="muted">
        Historical data may contain errors or incomplete matches. The map’s
        record limit does not apply to charts.
      </p>
      {state.loading && <p role="status">Loading trends…</p>}
      {state.error && (
        <div role="alert">
          <p>{state.error}</p>
          <button onClick={() => setRetry((n) => n + 1)}>Try again</button>
        </div>
      )}
      {state.data &&
        (state.data.every((rows) => rows.length === 0) ? (
          <p>No trend data matches these filters.</p>
        ) : (
          <>
            {state.data[0].length > 0 && <AvgChart data={state.data[0]} />}
            {state.data[1].length > 0 && (
              <EircodePriceChart data={state.data[1]} />
            )}
            {state.data[2]?.length > 0 && (
              <EircodeUndervaluedChart data={state.data[2]} />
            )}
          </>
        ))}
    </section>
  );
}
